export enum SubscriptionFunnelType {
    MonoEnergyElectricity = "MonoEnergyElectricity",
    MonoEnergyGas = "MonoEnergyGas",
    DualEnergy = "DualEnergy",
}
